import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate, Link } from "react-router-dom";
import {
  Card,
  Button,
  Form,
  Input,
  Row,
  Col,
  Alert,
  Spin,
  Steps,
  Typography,
} from "antd";
import { MailOutlined, WhatsAppOutlined } from "@ant-design/icons";

import { otp_email, otp_wa } from "src/redux/actions/auth";

import { clearMessage } from "src/redux/actions/message";
import swal from "sweetalert";

const { Title } = Typography;
const App = ({ email, wa, setCurrent, setVia, setEmail, setWa }) => {
  const [loading, setLoading] = useState(false);
  const [loadingWa, setLoadingWa] = useState(false);

  const { isLoggedIn } = useSelector((state) => state.auth);
  const { message } = useSelector((state) => state.message);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(clearMessage());
  }, []);

  if (isLoggedIn) {
    return <Navigate to="/" />;
  }

  // console.log("email: ", email);
  //console.log("wa: ", wa);

  const onFinishEmail = (values) => {
    console.log("Received values from form: ", values);

    setLoading(true);
    if (!loading) {
      dispatch(otp_email(values.email))
        .then(() => {
          swal("Success", "success", "success", {
            buttons: false,
            timer: 2000,
          });
          window.setTimeout(() => {
            //setSuccess(true);
            setLoading(false);
            setVia("email");
            setEmail(values.email);
            setCurrent(2);
            //navigate("/");
            //window.location.reload();
          }, 2000);
        })
        .catch(() => {
          swal("Error", message, "error", {
            buttons: false,
            timer: 1000,
          });
          setLoading(false);
        });
    }
  };

  const onFinishWA = (values) => {
    console.log("Received values from form: ", values);

    setLoadingWa(true);
    if (!loadingWa) {
      dispatch(otp_wa(values.wa))
        .then(() => {
          swal("Success", "success", "success", {
            buttons: false,
            timer: 2000,
          });
          window.setTimeout(() => {
            //setSuccess(true);
            setLoadingWa(false);
            setVia("wa");
            setWa(values.wa);
            setCurrent(2);

            //window.location.reload();
          }, 2000);
        })
        .catch(() => {
          swal("Error", message, "error", {
            buttons: false,
            timer: 1000,
          });
          setLoadingWa(false);
        });
    }
  };

  return (
    <>
      <Row>
        <Col>
          <Title level={5}> </Title>
        </Col>
      </Row>
      <Row
        justify="center"
        gutter="24"
        align="middle"
        style={{ height: "60%" }}
      >
        <Col>
          <Card title="Kirim Kode Via Email" style={{ width: 300 }}>
            <Form
              name="email_form"
              initialValues={{ remember: true, email: email }}
              onFinish={onFinishEmail}
            >
              <Form.Item
                name="email"
                rules={[
                  { required: true, message: "Tolong masukkan email Anda!" },
                ]}
              >
                <Input
                  placeholder="Email"
                  prefix={<MailOutlined />}
                  size="large"
                />
              </Form.Item>

              {/*!loading && message && (
                <Alert
                  message={message}
                  type="error"
                  showIcon
                  style={{ marginBottom: "16px" }}
                />
              )*/}
              <Form.Item>
                <Spin spinning={loading} delay={100}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    block
                    size="large"
                    shape="round"
                  >
                    Send OTP
                  </Button>
                </Spin>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </>
  );
};
export default App;
